import { render, staticRenderFns } from "./PlayerVoiceAssistant.vue?vue&type=template&id=c16f9b16&scoped=true&lang=html&"
import script from "./PlayerVoiceAssistant.vue?vue&type=script&lang=js&"
export * from "./PlayerVoiceAssistant.vue?vue&type=script&lang=js&"
import style0 from "./PlayerVoiceAssistant.vue?vue&type=style&index=0&id=c16f9b16&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c16f9b16",
  null
  
)

export default component.exports